export default __webpack_public_path__ + "static/media/23.e1ee6834.png";